export default "__VITE_ASSET__CHeZC_w1__"